import UserLevelMap from 'utils/user-level-map'

const getUserLevel = (user) => {
  const levelOfAccess = user?.Attributes?.find((attribute) => attribute.Name === 'custom:role')?.Value

  return UserLevelMap[levelOfAccess]
}

export default getUserLevel
